import { render, staticRenderFns } from "./SFUGenerate.vue?vue&type=template&id=4fcf152e&scoped=true&"
import script from "./SFUGenerate.vue?vue&type=script&lang=js&"
export * from "./SFUGenerate.vue?vue&type=script&lang=js&"
import style0 from "./SFUGenerate.vue?vue&type=style&index=0&id=4fcf152e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcf152e",
  null
  
)

export default component.exports